<admin-header [primaryButtons]="headerPrimaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<div class="form-container">
	<dx-form class="m-3" [(formData)]="item" [showColonAfterLabel]="true" labelLocation="top" [colCount]="2"  [readOnly]="readOnly">
			<dxi-item dataField="templateName"></dxi-item>
			<dxi-item dataField="subject"></dxi-item>
			<dxi-item dataField="senderName"></dxi-item>
			<dxi-item dataField="senderEmailAddress"></dxi-item>
	</dx-form>
	<email-editor (loaded)="editorLoaded" #editor></email-editor>
</div>